import { MEDIA_LIBRARY_URL, ROOT_URL } from "fleet/constant/media-library";
import { ConnectedMediaList } from "fleet/controller/media-library/connected-media-list";
import { ConnectedDeploymentListPage } from "fleet/controller/strategy-v2/connected-deploy-list";
import { ConnectedDeployPage } from "fleet/controller/strategy-v2/connected-deploy-page";
import { ConnectedStrategyV2DetailController } from "fleet/controller/strategy-v2/connected-detail-controller";
import { ConnectedStrategyV2ListPage } from "fleet/controller/strategy-v2/connected-list";
import { ConnectedScheduledDeploymentList } from "fleet/controller/strategy-v2/connected-strategy-scheduled-list";
import React from "react";
import { PrivateRoute } from "ui/private-route";
import { VIEW } from "view/views";

function renderStrategyV2Routes() {
  return [
    <PrivateRoute
      exact
      path={ROOT_URL}
      key="strategy-v2-list"
      render={(routeProps) => {
        return (
          <ConnectedStrategyV2ListPage
            {...routeProps}
            archived={false}
            viewUrl={`${ROOT_URL}/`}
          />
        );
      }}
    />,
    <PrivateRoute
      exact
      path={`${ROOT_URL}/archived`}
      key="strategy-v2-list-archived"
      render={(routeProps) => {
        return (
          <ConnectedStrategyV2ListPage
            {...routeProps}
            archived={true}
            viewUrl={`${ROOT_URL}/`}
          />
        );
      }}
    />,
    <PrivateRoute
      exact
      path={`${ROOT_URL}/deploy`}
      key="strategy-v2-deploy"
      component={ConnectedDeployPage}
    />,
    <PrivateRoute
      exact
      path={`${ROOT_URL}/deployments`}
      key="strategy-v2-deployments"
      component={ConnectedDeploymentListPage}
    />,
    <PrivateRoute
      exact
      path={`${ROOT_URL}/:id/:viewType(${VIEW.CLONE}|${VIEW.EDIT})`}
      key="strategy-v2-edit"
      component={ConnectedStrategyV2DetailController}
    />,
    <PrivateRoute
      exact
      path={MEDIA_LIBRARY_URL}
      key="strategy-v2-media-library"
      component={ConnectedMediaList}
    />,
    <PrivateRoute
      exact
      path={`${MEDIA_LIBRARY_URL}/folders/:id`}
      key="strategy-v2-media-library-folder"
      component={ConnectedMediaList}
    />,
    <PrivateRoute
      exact
      path={`${ROOT_URL}/:viewType(${VIEW.CREATE})`}
      key="strategy-v2-new"
      component={ConnectedStrategyV2DetailController}
    />,
    <PrivateRoute
      exact
      path={`${ROOT_URL}/scheduled`}
      key="strategy-v2-scheduled-deployments"
      component={ConnectedScheduledDeploymentList}
    />,
  ];
}

export { MEDIA_LIBRARY_URL, renderStrategyV2Routes };
